import { LineChartOutlined, TableOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'antd'
import PropTypes from 'prop-types'

export default function ChartTableSwitch({ viewMode, onChange }) {
  return (
      <Radio.Group
        onChange={e => onChange(e.target.value)}
        value={viewMode}
        size="small"
      >
        <Tooltip placement="top" title="Chart View">
          <Radio.Button value="chart" title="Chart View">
            <LineChartOutlined />
          </Radio.Button>
        </Tooltip>
        <Tooltip placement="top" title="Table View">
          <Radio.Button value="table" title="Table View">
            <TableOutlined />
          </Radio.Button>
        </Tooltip>
      </Radio.Group>
  )
}

ChartTableSwitch.propTypes = {
  viewMode: PropTypes.oneOf(['chart', 'table']).isRequired,
  onChange: PropTypes.func.isRequired,
}
